module.exports = __webpack_public_path__ + "static/media/saraback.d0f538fc.png";